export function getImageSrc(filename) {
    try {
        return require(`@/assets/images/${filename}`);
    } catch (e) {
        console.error(`Image not found: ${filename}`);
        return '';
    }
}

